/* eslint-disable */
import { useState, useContext, useEffect } from 'react'
import { PageContext } from '../../../context/PageContextProvider'
import { GeneralInput } from '../../core/input'
import { FormButton } from '../../core/button'
import styles from './index.module.scss'
import text from './text.json'
import translate from '../../../utils/translate'
import { LangArrows } from '../../../icons'
import SelectsAPI from '../../../api/selects'
import RecallAPI from '../../../api/recall'
import PagesAPI from '../../../api/pages'
import Loading from '../loading'

const Recall = () => {
  const { language } = useContext(PageContext)
  const DEFAULT_PAGE = {
    title: {
      AZ: 'Müraciət göndərin',
      ENG: 'Send an Application',
      RU: 'Отправить заявку',
      TR: 'Başvuru Gönderin',
    },
    description_az: 'Sualınız və ya təklifiniz var? Bizimlə əlaqə saxlayın.',
    description_eng: 'Do you have a question or suggestion? Contact us.',
    description_ru: 'У вас есть вопрос или предложение? Свяжитесь с нами.',
    description_tr: 'Sorunuz veya iş birliği teklifiniz mi var? Bizimle iletişime geçin.',
  }
  const DEFAULT_SUBJECTS = [
    {
      AZ: 'Xidmətlər üzrə konsultasiya (Xidmət almaq)',
      ENG: 'Consultation on services (Ordering a service)',
      RU: 'Консультация по услугам (Заказ услуги)',
      TR: 'Hizmet Danışmanlığı (Hizmet Alımı)',
    },
    {
      AZ: 'Biznes konsaltinq və idarəetmə',
      ENG: 'Business consulting and management',
      RU: 'Бизнес-консалтинг и управление',
      TR: 'İş Danışmanlığı ve Yönetim',
    },
    {
      AZ: 'Maliyyə, vergi və audit dəstəyi',
      ENG: 'Financial, tax and audit support',
      RU: 'Финансовая, налоговая и аудиторская поддержка',
      TR: 'Finans, Vergi ve Denetim Desteği',
    },
    {
      AZ: 'Əməkdaşlıq və tərəfdaşlıq təklifi',
      ENG: 'Cooperation and partnership proposal',
      RU: 'Предложение о сотрудничестве и партнерстве',
      TR: 'İş Birliği ve Ortaklık Teklifi',
    },
    {
      AZ: 'Karyera və komandaya qoşulmaq',
      ENG: 'Career and joining the team',
      RU: 'Карьера и присоединение к команде',
      TR: 'Kariyer ve Ekibe Katılım',
    },
    {
      AZ: 'Digər müraciət və ya təklif',
      ENG: 'Other inquiry or feedback',
      RU: 'Другое обращение или предложение',
      TR: 'Diğer Başvuru veya Öneri',
    },
  ]
  const [load, setLoad] = useState(true)
  const [bool, setBool] = useState(false)
  const [data, setData] = useState(DEFAULT_SUBJECTS)
  const [page, setPage] = useState(DEFAULT_PAGE)
  const [choice, setChoice] = useState(text.subject[language] || text.subject.AZ)

  useEffect(() => {
    setChoice(text.subject[language] || text.subject.AZ)
  }, [language])

  useEffect(() => {
    (async () => {
      try {
        const { data: subData } = await SelectsAPI.getSubject()
        if (subData && subData.length > 0) {
          setData(subData)
        }
      } catch (err) {
        console.warn('Using default subjects')
      }
      try {
        const data1 = await PagesAPI.getRequest()
        if (data1?.data?.title) {
          setPage(data1.data)
        }
      } catch (err) {
        console.warn('Using default request page data')
      }
    })()
  }, [])
  const sendAppeal = async (e) => {
    e.preventDefault()
    const fullname = document.querySelector('#fullname').value.trim()
    const subject = choice
    const contact = document.querySelector('#contact').value.trim()
    if (
      fullname === '' ||
      contact === '' ||
      subject === text.subject['AZ'] ||
      subject === text.subject['ENG'] ||
      subject === text.subject['RU'] ||
      subject === text.subject['TR']
    ) {
      alert(translate.alert[language] || translate.alert.AZ)
      return
    }

    const formData = {
      fullname,
      contact,
      subject,
    }
    const data = await RecallAPI.insert(formData)
    if (data.status === 200) {
      alert(translate.alert_form[language] || translate.alert_form.AZ)
      document.querySelector('#fullname').value = ''
      document.querySelector('#contact').value = ''
      setChoice(text.subject[language] || text.subject.AZ)
    }
  }
  return load ? (
    <section className={styles.container}>
      <h2>{page?.title?.[language] || 'Müraciət edin'}</h2>
      <form onSubmit={sendAppeal}>
        <GeneralInput
          id="fullname"
          type="text"
          placeholder={text.fullname[language]}
          label={translate.fullname[language]}
        />
        <div>
          <div
            className={styles.select}
            onBlur={() =>
              setTimeout(function () {
                setBool(false)
              }, 250)
            }
          >
            <p>{translate.subject[language]}</p>
            <span tabIndex="1" onClick={() => setBool(true)}>
              {choice} <LangArrows />
            </span>
            <ul style={bool ? { display: 'block' } : { display: 'none' }}>
              {data.map((e, idx) => (
                <li
                  key={idx}
                  onClick={() => {
                    setChoice(e[language] || e.TR || e.AZ)
                  }}
                >
                  {e[language] || e.TR || e.AZ}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <GeneralInput
          id="contact"
          type="text"
          placeholder={text.email[language]}
          label={translate['phone/mail'][language]}
        />
        <FormButton type="submit">{text.button[language]}</FormButton>
      </form>
    </section>
  ) : (
    <Loading />
  )
}

export default Recall
